export { default as SyncStore } from './SyncStore';



// WEBPACK FOOTER //
// ./src/modules/sync/stores/index.js